import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import CallFAB from "./CallFAB";
import NiceJobWidget from "../widgets/NiceJobWidget";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col overflow-x-hidden">
      <Header />
      <main className="flex-1 pt-14 sm:pt-16 md:pt-20">{children}</main>
      <Footer />
      <CallFAB />
      <NiceJobWidget />
    </div>
  );
};

export default Layout;
